export default "__VITE_ASSET__136f32af__"